$(document).ready(function() {
  var intervalId = null;
  var varName = function() {
    if ($(".quick-add-modal__content-info .slider-nav").hasClass("slick-initialized")) {
      clearInterval(intervalId);
      console.log("slider added");
    } else {
      console.log("slider not added");
      $('.slider_desk_slick').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
      });
      $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        asNavFor: '.slider_desk_slick',
        dots: false,
        focusOnSelect: true,
        verticalSwiping: true,
        arrows: true,
      });
    }
    $('.size-chart-open-popup').click(function() {
      $(this).parents('.quick-add-modal__content').addClass("size_guid_popup");
      $(this).parents('body').find('.product-popup-modal').attr("open", "open");
    });
    $('.product-popup-modal__toggle').click(function() {
      $(this).parents('.product-popup-modal').removeAttr("open");
      $(this).parents('body').find('.quick-add-modal__content').removeClass("size_guid_popup");
    });
    if ($(window).width() < 992) {
      $('.slick_slider_nav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true,
        dots: false,
        infinite: false,
        arrows: true,
      });
      $('.slick_slider_nav').slick('slickGoTo', 0);
    }
  };
  $('.home-top-banner .Banner_wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: false
  });
  if ($(window).width() < 992) {
    $('.slick_slider_nav').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: true,
      dots: true,
      infinite: false,
    });
    $('.slick_slider_nav').slick('slickGoTo', 0);
  }
  if ($(".product__info-wrapper").length > 0) {
    $(document).scroll(function() {
      var w = $(window);
      var offset = $(".product__info-wrapper .product-form__buttons").offset();
      var btnheight = parseFloat(offset.top - w.scrollTop());
      if (btnheight <= 0) {
        $('.product_bottom_fixed').fadeIn();
        $('.product_bottom_fixed').addClass('active');
      } else {
        $('.product_bottom_fixed').fadeOut();
        $('.product_bottom_fixed').removeClass('active');
      }
    });
  }
  $('.quick-add__submit').on("click", function() {
    intervalId = setInterval(varName, 50);
    $('body').addClass('quick_modal_open');
  });
  // Zoom functionality
  $('.zoom-item img').on('mouseover', function() {
    var zoomImageSrc = $(this).data('zoom');
    $('.zoom-container img').attr('src', zoomImageSrc);
  });
});